import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button, Container, TextField, IconButton, Tooltip, InputAdornment } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DownloadIcon from '@mui/icons-material/Download';
import PublishIcon from '@mui/icons-material/Publish';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import LinkIcon from '@mui/icons-material/Link';
import { toast } from 'react-toastify';
import Menu from '../../models/menu';
import { downloadMenuHtml } from './menuHtmlExport';
import MenuPreviewContent from './MenuPreviewContent';

const MenuPreview = ({ setPageTitle }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [menuData, setMenuData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [publishing, setPublishing] = useState(false);
  const [publicUrl, setPublicUrl] = useState('');

  useEffect(() => {
    setPageTitle('Xem trước Menu');
    const fetchMenu = async () => {
      try {
        const menuModel = new Menu();
        const data = await menuModel.getMenuById(id);
        setMenuData(data);
        if (data?.public_url) setPublicUrl(data.public_url);
      } catch (err) {
        console.error('Error fetching menu:', err);
      } finally {
        setLoading(false);
      }
    };
    if (id) fetchMenu();
  }, [id, setPageTitle]);

  const handlePublish = async () => {
    setPublishing(true);
    try {
      const menuModel = new Menu();
      const result = await menuModel.publishMenu(id);
      if (result.success) {
        setPublicUrl(result.url);
        toast.success(result.message);
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      toast.error('Có lỗi xảy ra khi xuất menu');
    } finally {
      setPublishing(false);
    }
  };

  const handleCopyUrl = () => {
    if (publicUrl) {
      navigator.clipboard.writeText(publicUrl);
      toast.success('Đã sao chép link');
    }
  };

  if (loading) return <Container sx={{ mt: 4, textAlign: 'center' }}>Đang tải...</Container>;
  if (!menuData) return <Container sx={{ mt: 4, textAlign: 'center' }}>Không tìm thấy menu</Container>;

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 24px', borderBottom: '1px solid #e0e0e0', gap: 12, flexWrap: 'wrap' }}>
        <Button startIcon={<ArrowBackIcon />} onClick={() => navigate(-1)}>Quay lại</Button>
        {publicUrl && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 1, maxWidth: 500 }}>
            <LinkIcon color="success" fontSize="small" />
            <TextField
              size="small"
              value={publicUrl}
              fullWidth
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip title="Sao chép link">
                      <IconButton size="small" onClick={handleCopyUrl}>
                        <ContentCopyIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
            />
            <Button size="small" variant="text" href={publicUrl} target="_blank">Mở</Button>
          </div>
        )}
        <div style={{ display: 'flex', gap: 8 }}>
          <Button
            startIcon={<PublishIcon />}
            variant="outlined"
            color="success"
            onClick={handlePublish}
            disabled={publishing}
          >
            {publishing ? 'Đang xuất...' : 'Xuất & Chia sẻ'}
          </Button>
          <Button startIcon={<DownloadIcon />} variant="contained" onClick={() => downloadMenuHtml(menuData)}>
            Tải HTML
          </Button>
        </div>
      </div>
      <MenuPreviewContent menuData={menuData} />
    </>
  );
};

export default MenuPreview;
